import { render, staticRenderFns } from "./purchase-order-number.vue?vue&type=template&id=5084a97c&"
import script from "./purchase-order-number.vue?vue&type=script&lang=js&"
export * from "./purchase-order-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports